import { useState } from "react";
import useSupportStore from "../../stores/useSupportStore";

function formatDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  return d.toLocaleDateString() + " " + d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

const TicketDetail = () => {
  const { selectedTicketDetail, selectedTicketId, addComment } = useSupportStore();
  const { selectTicket } = useSupportStore();
  const [commentText, setCommentText] = useState("");

  if (!selectedTicketDetail) {
    return <div style={{ textAlign: "center", padding: 40, color: "#999" }}>Loading...</div>;
  }

  const { ticket, comments } = selectedTicketDetail;

  const handleAddComment = () => {
    if (!commentText.trim()) return;
    addComment(selectedTicketId, commentText.trim());
    setCommentText("");
  };

  const handleBack = () => {
    useSupportStore.setState({ selectedTicketId: null, selectedTicketDetail: null });
  };

  return (
    <div>
      <button className="support-back-btn" onClick={handleBack}>&larr; Back to tickets</button>

      <div className="support-detail-info">
        <span className="support-detail-label">Ticket</span>
        <span className="support-detail-value" style={{ fontFamily: "monospace" }}>
          {ticket.ticketNumber || ticket.localId}
        </span>

        <span className="support-detail-label">Status</span>
        <span className="support-detail-value">
          <span className={`support-badge ${ticket.status}`}>{ticket.status.replace(/_/g, " ")}</span>
        </span>

        <span className="support-detail-label">Priority</span>
        <span className="support-detail-value">
          <span className={`support-badge ${ticket.priority}`}>{ticket.priority}</span>
        </span>

        <span className="support-detail-label">Category</span>
        <span className="support-detail-value">{ticket.category}</span>

        <span className="support-detail-label">Subject</span>
        <span className="support-detail-value">{ticket.subject}</span>

        {ticket.description && (
          <>
            <span className="support-detail-label">Description</span>
            <span className="support-detail-value">{ticket.description}</span>
          </>
        )}

        <span className="support-detail-label">Created</span>
        <span className="support-detail-value">{formatDate(ticket.createdAt)}</span>

        {ticket.syncStatus === "pending" && (
          <>
            <span className="support-detail-label">Sync</span>
            <span className="support-detail-value" style={{ color: "#f57f17" }}>Pending sync</span>
          </>
        )}
      </div>

      {/* Items */}
      {ticket.items && (() => {
        try {
          const parsed = typeof ticket.items === "string" ? JSON.parse(ticket.items) : ticket.items;
          if (parsed.length > 0) {
            return (
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Issues ({parsed.length})</div>
                {parsed.map((item, i) => (
                  <div key={i} className="support-item-row">
                    <span className="item-category">{item.category}</span>
                    <span className="item-desc">{item.description}</span>
                  </div>
                ))}
              </div>
            );
          }
        } catch {}
        return null;
      })()}

      {/* Comments */}
      <div className="support-comments">
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>
          Comments ({comments?.length || 0})
        </div>

        {comments && comments.length > 0 ? (
          comments.map((comment, i) => (
            <div key={i} className="support-comment device">
              <div className="support-comment-author">
                {comment.authorName || "POS User"}
                <span className="support-comment-time">{formatDate(comment.createdAt)}</span>
              </div>
              <div>{comment.content}</div>
            </div>
          ))
        ) : (
          <div style={{ fontSize: 12, color: "#999", textAlign: "center", padding: 16 }}>
            No comments yet
          </div>
        )}

        <div className="support-comment-input">
          <input
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            placeholder="Add a comment..."
            onKeyDown={(e) => e.key === "Enter" && handleAddComment()}
          />
          <button onClick={handleAddComment} disabled={!commentText.trim()}>Send</button>
        </div>
      </div>
    </div>
  );
};

export default TicketDetail;
